import { useIsSerialNumberTrackingAvailable } from '../../feature-gates/use-is-serial-number-tracking-available';
import { useSerialNumberEnforcementSetting } from '../../hooks/use-seller-setting';
import { SerialEnforcementLevel } from './constants';

// Falls back to Allow (no gating at all) whenever serial number tracking isn't available, so an ungated
// seller sees zero behavior change anywhere that consumes this hook, regardless of what the seller
// setting is persisted as.
export const useSerialEnforcementLevel = (): SerialEnforcementLevel => {
  const { isAvailable: isSerialNumberTrackingAvailable } = useIsSerialNumberTrackingAvailable();
  const settingLevel = useSerialNumberEnforcementSetting();

  return isSerialNumberTrackingAvailable ? settingLevel : SerialEnforcementLevel.Allow;
};
